import React from 'react';
import Uganda1_advanced_secondary_subjects from './uganda1_advanced_secondary_subjects';

const Uganda1_advanced_secondary = () => {
  return (
    <div>
      <Uganda1_advanced_secondary_subjects />
    </div>
  );
}

export default Uganda1_advanced_secondary;
